import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IResult } from "../interface/IResult";
import { ISpreadAdministratorAndConsulterResponse } from "../interface/spread/ISpreadAdministratorAndConsulterResponse";
import { ISpreadGlobalResponse } from "../interface/spread/ISpreadGlobalResponse";

enum SpreadServiceEnum {
    save = "/administrator/consulter",
    getById = "/administrator/consulter/",
    getAll = "/administrator/consulter/all",
    update = "/administrator/consulter",

    saveGlobal = "/global",
    globalGetById = "/global/",
    globalGetAll = "/global/all",
    globalUpdate = "/global"
}

export default class SpreadService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/spread");
    }

    public save = async data => await this.POST(SpreadServiceEnum.save, data);
    public getById = async id => await this.GET(SpreadServiceEnum.getById + id);
    public getAll = async (): Promise<IResult<ISpreadAdministratorAndConsulterResponse[]>> => this.GET(SpreadServiceEnum.getAll);
    public update = async data => await this.PUT(SpreadServiceEnum.update, data);

    public saveGlobal = async data => await this.POST(SpreadServiceEnum.saveGlobal, data);
    public globalGetById = async id => await this.GET(SpreadServiceEnum.globalGetById + id);
    public globalGetAll = async (): Promise<IResult<ISpreadGlobalResponse[]>> => this.GET(SpreadServiceEnum.globalGetAll);
    public globalUpdate = async data => await this.PUT(SpreadServiceEnum.globalUpdate, data);
}



// WEBPACK FOOTER //
// ./src/services/api/Spread.service.ts